import {
    getSelectedCalendarsFlatList,
    selectedCalendarsUpdated,
} from 'owa-calendar-module-selected-calendars-user-config';
import { getUpNextEventLockId } from 'owa-calendar-surface-events-lock-store';
import { updateUpNextCalendarIds } from 'owa-upnext-event-loader';
import { orchestrator } from 'satcheljs';

export const selectedCalendarsUpdatedOrchestrator = orchestrator(selectedCalendarsUpdated, () => {
    const selectedCalendars = getSelectedCalendarsFlatList();
    updateUpNextCalendarIds(selectedCalendars, getUpNextEventLockId());
});
